module.exports = __webpack_public_path__ + "img/IMG_9874.326d912b.png";